import React, { useState, useCallback, useEffect } from 'react';
import { TextField } from '@shopify/polaris';

export function QuantityFieldCustom(props) {

    const format = function (val) {
        if (val === null) {
            val = "";
        }

        let newValue = val?.toString();
        if (!newValue) {
            return newValue;
        }

        let newValueInt = parseInt(newValue);
        return newValueInt.toString();
    }

    const [value, setValue] = useState(format(props.value));

    const handleValueChange = useCallback(
        (newValue) => {
            const re = /^[0-9\b]+$/;
            if (newValue === '' || re.test(newValue)) {
                setValue(newValue);
                props.handleChange(props.fieldName, newValue);
            }
        },
        [props],
    );

    const handleBlur = useCallback(
        () => {
            let newValue = format(value);

            props.handleError(props.fieldName, props.required && (!newValue || parseInt(newValue) === 0));

            if (!props.required && !newValue) {
                newValue = 0;
            }

            setValue(newValue);
            props.handleChange(props.fieldName, newValue);
        },
        [value, props],
    );

    useEffect(() => {
        setValue(format(props.value));
    }, [props.value]);

    return (
        <TextField
            id={props.id}
            value={value}
            label={props.label}
            helpText={props.helpText}
            suffix={props.suffix}
            error={props.error}
            disabled={props.disabled}
            onChange={(newValue) => handleValueChange(newValue)}
            onBlur={() => handleBlur()}
        />
    );
}